import {get_query_search_param, stripHtml} from "../utils";

export default {
    namespaced: true,
    state: {
        courses: null,
        search: get_query_search_param(window.location.search)?.search || '',
        searchData: [],
        searchCount: 0,
        module: null,
        moduleLessonId: 0
    },
    mutations: {
        setModule(state, payload) {
            state.module = payload;
        },
        setSearch(state, payload) {
            state.search = payload
        },
        setCourses(state, payload) {
            state.courses = payload;
        },
        setModuleLessonId(state, id) {
            state.moduleLessonId = Number(id)
        }
    },
    getters: {
        getLesson: ({module, moduleLessonId}) => (search = '') => {
            const lesson = module.lessons.find(({id}) => id === moduleLessonId)
            const q = search.trim()
            if(q) {
                var regEx = new RegExp(q.split(" ").join("|"), 'gi')
                lesson.text = lesson.text.replace(regEx, match => `<span class="search_sp">${match}</span>`)
            }
            return lesson;
        },
        getSearchData: state => {
            const q = state.search.trim()
            const result = []
            if(q && state.courses !== null) {
                const qForRegEx = q.split(" ").join("|");
                const regEx = new RegExp('.{0,128}' + qForRegEx + '.{0,128}', 'gi')
                state.courses.map(course => {
                    const module = course.modules[0];
                    module.lessons.forEach(lesson => {
                        const search = []
                        const text = stripHtml(lesson.text)
                        if(regEx.test(text)) {
                            text.replace(regEx, (match) => {
                                const res = match.split(/\s+/).filter(w => w === q || w.length > 1).join(' ')
                                    .replace(new RegExp(`(.*)(${qForRegEx})(.*)`, 'gi'), '$1<span class="search_sp">$2</span>$3').replace(/^,|,$/, "")
                                search.push(res)
                            })
                        }
                        result.push({lesson: {...lesson, course}, search})
                    })
                })
            }
            let count = 0;
            const data = result.filter(({search}) => {count += (search?.length || 0); return search?.length})
            return {data: result, count };
        }

    },
    actions: {
        getModule({commit}, params = {}) {
            return window.http.get('/api/courses/module', {params}).then(response => {
                commit('setModule', response.data);
            });
        },
        getCourses({commit}) {
            window.http.get('/api/courses/get').then(response => {
                commit('setCourses', response.data)
            });
        }

    },
}
